<div
  [class]="
    isKiosk() ? 'absolute inset-0 flex flex-col items-center justify-center gap-14 px-32' : 'pt-4'
  "
>
  <p
    [id]="questionId()"
    [class]="
      isKiosk()
        ? 'w-full text-center text-6xl font-bold'
        : 'mb-4 mt-5 font-accent text-md font-bold md:mt-6'
    "
    [style.color]="textColor() | contentBuilderColor"
  >
    {{
      question()
        | translateField
          : {
              defaultTranslationKey: 'cart-funnel.minimum-age.question',
              params: translationParams(),
            }
    }}
  </p>

  <div
    role="radiogroup"
    [attr.aria-labelledby]="questionId()"
    [class]="'grid w-full grid-cols-2 ' + (isKiosk() ? 'gap-10' : 'gap-3')"
  >
    <button
      type="button"
      role="radio"
      [class]="
        isKiosk()
          ? 'flex items-center justify-center border-6 font-bold'
          : 'flex items-center justify-center border-2 px-4 font-accent font-bold'
      "
      [attr.aria-checked]="choice() === 'no'"
      [style.color]="
        (choice() === 'no' ? selectedTextColor() : choiceTextColor()) | contentBuilderColor
      "
      [style.backgroundColor]="
        (choice() === 'no' ? selectedBackgroundColor() : choiceBackgroundColor())
          | contentBuilderColor
      "
      [style.borderColor]="choiceBorderColor() | contentBuilderColor"
      [style.fontSize.px]="buttonFontSize()"
      [style.borderRadius.px]="buttonRadius()"
      [style.minHeight.px]="buttonMinHeight()"
      (click)="choose('no')"
    >
      {{
        noLabel()
          | translateField
            : {
                defaultTranslationKey: 'cart-funnel.minimum-age.no',
                params: translationParams(),
              }
      }}
    </button>
    <button
      type="button"
      role="radio"
      [class]="
        isKiosk()
          ? 'flex items-center justify-center border-6 font-bold'
          : 'flex items-center justify-center border-2 px-4 font-accent font-bold'
      "
      [attr.aria-checked]="choice() === 'yes'"
      [style.color]="
        (choice() === 'yes' ? selectedTextColor() : choiceTextColor()) | contentBuilderColor
      "
      [style.backgroundColor]="
        (choice() === 'yes' ? selectedBackgroundColor() : choiceBackgroundColor())
          | contentBuilderColor
      "
      [style.borderColor]="choiceBorderColor() | contentBuilderColor"
      [style.fontSize.px]="buttonFontSize()"
      [style.borderRadius.px]="buttonRadius()"
      [style.minHeight.px]="buttonMinHeight()"
      (click)="choose('yes')"
    >
      {{
        yesLabel()
          | translateField
            : {
                defaultTranslationKey: 'cart-funnel.minimum-age.yes',
                params: translationParams(),
              }
      }}
    </button>
  </div>

  @if (choice() === 'no') {
    <p
      role="alert"
      [id]="messageId()"
      [class]="isKiosk() ? 'w-full text-center text-3xl font-bold' : 'mt-3 text-sm'"
      [style.color]="messageColor() | contentBuilderColor"
    >
      {{
        denialMessage()
          | translateField
            : {
                defaultTranslationKey: 'cart-funnel.minimum-age.denied',
                params: translationParams(),
              }
      }}
    </p>
  }
</div>
